var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"team-member flex flex-col w-full sm:w-1/2 lg:w-1/4 p-4 mb-4 text-center"},[_c('img',{staticClass:"rounded mb-6",attrs:{"src":_vm.image}}),_c('a',{staticClass:"text-xl font-black cursor-pointer",attrs:{"href":_vm.twitter}},[_vm._v(_vm._s(_vm.name))]),_c('p',[_vm._v(_vm._s(_vm.position))])])
}
var staticRenderFns = []

export { render, staticRenderFns }